import React, { useState } from 'react';
import { Document, Page } from 'react-pdf';

import image4 from "../../Assets/Img/image4.png"
import image3 from "../../Assets/Img/image3.png"
import image5 from "../../Assets/Img/image5.png"
// import "./Header.scss"
import { Link } from 'react-router-dom';
import BirinchiIkkinchi from '../../Pages/Birinchi_ikkinchi/Birinchi_ikkinchi';
import Yuklangan from '../Yuklanganlar/Yuklangan';
import Yuklangan3 from '../Yuklanganlar3/Yuklanganlar3';
const Header3 = () => {
  const uquvchi = [
    {
      id:1,
      materialName: "Suq",
      author: "Zufiya",
      file: "pdf",
      photo: "../image/",
      file_name: "../zulfiya_suq.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:2,
      materialName: "o'tkan kunlar 1-qism",
      author: "Abdulla Qodiriy",
      file: "mp3",
      photo: "/image/utkan kunlar.jpg",
      file_name: "/01_otkan_kunlar.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:3,
      materialName: "O'tkan kunlar 2-qism",
      author: "Abdulla Qodiriy",
      file: "mp3",
      photo: "/image/utkan kunlar.jpg",
      file_name: "/02_otkan_kunlar.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:4,
      materialName: "O'tkan kunlar 4-qism",
      author: "Abdulla Qodiriy",
      file: "mp3",
      photo: "/image/utkan kunlar.jpg",
      file_name: "/04_otkan_kunlar.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:5,
      materialName: "60 yoshda san'atning nurli yo'li",
      author: "Farg'ona kolleki",
      file: "mp3",
      photo: "/image/nurli_yul.jpg",
      file_name: "60_yoshda_sanatning_nurli_yoli.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:6,
      materialName: "Abay she'rlar va poemalari",
      author: "Abay",
      file: "pdf",
      photo: "../image/abay.jpg",
      file_name: "../abay_sherlar_va_poemalar.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:7,
      materialName: "Yana Bahor hokim",
      author: "Zulfiya",
      file: "mp3",
      photo: "",
      file_name: "../zulfiya_yana_bahor_hokim.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:8,
      materialName: "Yillar Sadosi",
      author: "Zulfiya",
      file: "pdf",
      photo: "../image/",
      file_name: "../zulfiya_yillar_sadosi.pdf",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:9,
      materialName: "Torga Tashrif",
      author: "Zulfiya",
      file: "mp3",
      photo: "../image/",
      file_name: "../zulfiya_torga_tashrif.mp3",
      roll: ['student'],
      categories: ['student']
    },
    {
      id:10,
      materialName: "Tong",
      author: "Zulfiya",
      file: "mp3",
      photo: "../image/",
      file_name: "../zulfiya_tong.mp3",
      roll: ['student'],
      categories: ['student']
    },
  ]
  const arxiv = [
    {
      id: 1,
      materialName: "alvido_qurol_ernest_xemenguej",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/alvido_qurol_ernest_xemenguej.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 2,
      materialName: "asqad_muxtor_chinor_romani",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/asqad_muxtor_chinor_romani_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 3,
      materialName: "axmad_azam_hali_hayot_bor_",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/axmad_azam_hali_hayot_bor_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 4,
      materialName: "ayyor_quyoncha_haqida_ertak",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/ayyor_quyoncha_haqida_ertak.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 5,
      materialName: "besh_bolali_yigitcha",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/besh_bolali_yigitcha.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 6,
      materialName: "burgutlar",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/burgutlar.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 7,
      materialName: "erkin_azam_suv_yoqalab",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/erkin_azam_suv_yoqalab.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 8,
      materialName: "erkin_va_farovon_demokratik_ozbekiston_davlatini_birgalikda_barpo_etamiz",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/erkin_va_farovon_demokratik_ozbekiston_davlatini_birgalikda_barpo_etamiz.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 9,
      materialName: "erkin_voxidov_soz_latofati_",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/erkin_voxidov_soz_latofati_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 10,
      materialName: "gabriel_garsia_markes_yolgizlikning_yuz_jili_",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/gabriel_garsia_markes_yolgizlikning_yuz_jili_.pdf",
      roll: ['public'],
      categories: ['student']
    },
    {
      id: 11,
      materialName: "iqrornoma_lev_tolstoj",
      author: "",
      file: "pdf",
      photo: "../image/",
      file_name: "/kitoblar/iqrornoma_lev_tolstoj.pdf",
      roll: ['public'],
      categories: ['student']
    },
  ]
  const app = [
    {
      id: 1,
      materialName: "MPCHC.exe",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/MPCHC.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 2,
      materialName: "pdf-cracker-setup",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/pdf-cracker-setup.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 3,
      materialName: "Photoshop",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/Photoshop.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 4,
      materialName: "PotPlayer",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/PotPlayer.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 5,
      materialName: "Rufus 2.6",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/Rufus2.6.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 6,
      materialName: "Total Commander Power Pack8.0.1x86",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/TotalCommanderPowerPack8.0.1x86.exe",
      roll: ['student'],
      categories: ['public']
    },
    {
      id: 7,
      materialName: "UltraISO",
      author: "",
      file: "app",
      photo: "",
      file_name: "/app/UltraISO.exe",
      roll: ['student'],
      categories: ['public']
    },

  ]
  const [student, setStudent] = useState(uquvchi)
  console.log(student);
  return (
    <div>
      <div className='header' style={{ display: "flex", justifyContent: "center", margin: "40px auto" }}>
        <h1>Mening malumotlarim!</h1>
        <div className='header__render'>
          <Link to="/BirinchiIkkinchi3" className='card'>
            <img className='card__img' src={image4} alt="" />
            <h2>{student.length}</h2>
            <h4>1-2-3-4 kurs materiallari</h4>
          </Link>
          <Link to="/Arxiv3" className='card'>
            <img className='card__img' src={image3} alt="" />
            <h2>{arxiv.length}</h2>
            <h4>Raqamli arxiv</h4>
          </Link>
          <Link to="/BoshqaApp" className='card'>
            <img className='card__img' src={image5} alt="" />
            <h2>{app.length}</h2>
            <h4>Dasturiy ta'minot</h4>
          </Link>
        </div>
      </div>
      <Yuklangan3/>
    </div>
  );
}

export default Header3;
